
import React, { useEffect, useRef, useState } from 'react';
import { Animated, Image, ImageSourcePropType, PixelRatio, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useDimensions } from 'react-native-web-hooks';
import * as funcs from "../../components/functions";
import { Action } from '../../shell/Actions/Action';
import Character from '../../shell/Character';
import { endReplayFunc } from '../../shell/endReplay';
import Game from '../../shell/Game';
import useFontSize from '../../shell/hooks/useFontSize';
import { onDiscordPressed, onExitGame, onGetAllSaves, onGetFiles, onMenuClosed, onPatreonPressed, onSetSettings, onSteamPressed } from '../../shell/utils/appManagementFunctions';
import { isMobile } from '../../shell/utils/platformCheck';
import { WaitForLoadImage } from '../../shell/ImageHandler/WaitForLoadImage';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { resetIndex, setVersion } from '../../store/slices/gameObjectSlice';
import { selectMenu, setMenu, setSettings } from '../../store/slices/menuSlice';
import { store } from '../../store/store';
import { parseRequire } from '../../utils/parseImageUrl';
import { PromptQuestionModal } from '../PromptQuestionModal';
import { Credit } from './Credit';
import { saveObjectMetaData } from './SaveLoad';
import { SaveLoadScreen } from './SaveLoadScreen';
import { Achievements } from './Scenes/Achievements';
import { Gallery } from './Scenes/gallery/Gallery';
import { Settings } from './Settings';
import { MenuOptions, SideBar } from './SideBar';
import { TPicker } from './TPicker';



interface TMainMenuProps {

}
const menuImages: { [key in MenuOptions]?: ImageSourcePropType } = {
    // [MenuOptions.SETTINGS]: parseRequire(require("@lss/common/game/assets/images/Menu/SettingsBackground.webp")),
    // [MenuOptions.CREDIT]: parseRequire(require("@lss/common/game/assets/images/Menu/SettingsBackground.webp")),
    [MenuOptions.INIT]: parseRequire(require("@lss/common/game/assets/images/Menu/MenuNoButtons.webp"))
};


export const MainMenu: React.FC<TMainMenuProps> = ({ }) => {
    const dispatch = useAppDispatch();
    const { width, height } = useDimensions().window;
    const [pageJumpModal, setPageJumpModal] = useState(false);
    const menuSlice = useAppSelector(selectMenu);
    const opacity = useRef(new Animated.Value(0));
    const prevPage = useRef<string | number>();
    const fontSize = useFontSize(4);
    const [background, setBackground] = useState(menuImages.INIT);
    // const [initialized, setInitialized] = useState(false);
    const initialized = useRef(false);
    const patreonImage = parseRequire(require("@lss/common/game/assets/images/Menu/Patreon.webp"));
    const discordImage = parseRequire(require("@lss/common/game/assets/images/Menu/Discord.webp"));
    const steamImage = parseRequire(require("@lss/common/game/assets/images/Extras/steamLogo.webp"));
    const wishlistImage = parseRequire(require("@lss/common/game/assets/images/Extras/alexwishlist.webp"));
    const [showGallery, setShowGallery] = useState(false);
    const [saves, setSaves] = useState<Map<string, Map<string, saveObjectMetaData>>>();
    const isUnmounted = useRef(false);
    const styles = StyleSheet.create({
        container: {
            position: "absolute",
            width: "100%",
            height: "100%",
            display: menuSlice.display ? "flex" : "none",
            zIndex: 1000,
        },
        menuImage: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            zIndex: -1,
            position: "absolute"
        },
        leftSide: {
            flexBasis: "28.379%",
            zIndex: 999,
        },
        wishlistContainer: {
            position: "absolute",
            bottom: 0,
            width: "100%",
            margin: "auto"
        },
        wishlistImage: {
            aspectRatio: 1920 / 588,
            left: "45%",
            width: "40%",
            opacity: 0.9
        },
        sideBar: {
            position: "absolute",
            height: "100%",
            width: "100%",
            justifyContent: "flex-start",
            backgroundColor: "#0000009c",


        },
        rightSide: {
            backgroundColor: menuSlice.menuState === MenuOptions.INIT || menuSlice.menuState === MenuOptions.EXIT || menuSlice.menuState === MenuOptions.NEW_GAME ? "transparent" : "#0000009c",
            flex: 3.5,
        },
        header: {
            flexDirection: "column",
            marginTop: "1%"

        },
        headerText: {
            fontSize: useFontSize(3),
            color: "whitesmoke",
            // marginLeft: 50 / PixelRatio.get(),
            textAlign: "center"
        },
        upperButtonsRight: {
            position: "absolute",
            right: 0,
            flexDirection: "row",
            marginTop: "1.5%",
            marginRight: "3%",

        },
        upperButtonsLeft: {
            position: "absolute",
            left: "28.379%",
            flexDirection: "row",
            marginTop: "1.5%",
            marginRight: "3%",

        },
        patreonLink: {
            height: useFontSize(8),
            aspectRatio: 1,

        },


    });
    useEffect(() => {

        doAnimate();
        setTimeout(() => {
            onGetAllSaves().then(res => {
                initialized.current = true;
                setSaves(res);
            });
        }, 300);

        return () => {
            isUnmounted.current = true;
        };
    }, []);

    useEffect(() => {
        if (menuSlice.display === false) {
            opacity.current.setValue(0);
        } else {
            if (menuSlice.menuState !== MenuOptions.INIT) {

                doAnimate();
            }

        }

        if (menuImages[menuSlice.menuState]) {
            setBackground(menuImages[menuSlice.menuState]);
        } else {
            setBackground(menuImages.INIT);
        };

        return () => {
            onMenuClosed();

        };
    }, [menuSlice]);


    useEffect(() => {
        if (menuSlice.settings.initialized === false) { return; }

        if (!initialized.current || (!saves)) {
            if (menuSlice.settings.page != null) {
                onGetFiles(menuSlice.settings).then(res => {
                    const map = new Map();
                    map.set(menuSlice.settings.page?.toString(), res);
                    // check again to prevent race condition
                    if (!initialized.current) {
                        setSaves(map);
                    }
                    // saves.set(menuSlice.settings.page?.toString(), res);
                    // setSaves(new Map(menuSlice.settings.page?.toString(), res));
                });
            }
        } else if (menuSlice.display && menuSlice.settings.page === "A" && menuSlice.menuState === MenuOptions.LOAD) {
            onGetFiles(menuSlice.settings).then(res => {
                const map = new Map();
                map.set(menuSlice.settings.page?.toString(), res);
                setSaves(saves => {
                    if (saves?.set && menuSlice.settings.page?.toString()) {

                        saves.set(menuSlice.settings.page.toString(), res);
                    }
                    return saves;
                });
            });
        }
        else if (menuSlice.settings.folder !== prevPage.current) {
            onGetAllSaves(menuSlice.settings.folder).then(res => {
                setSaves(res);
            });
        }
        if (menuSlice.menuState !== MenuOptions.INIT) {
            onSetSettings();
        }
        prevPage.current = menuSlice.settings.folder;


    }, [menuSlice.settings]);




    const onValueChanged = async (value: string) => {
        dispatch(setSettings({ folder: value }));
        // if (initialized) {
        //     onGetAllSaves(value).then(res => {
        //         setSaves(res);
        //     });
        // } else {
        //     const pageSaves = await onGetFiles(menuSlice.settings.page);
        // }
    };

    const onNewGame = () => {
        // dispatch(resetGameObject());
        store.dispatch({ type: "reset" });
        store.dispatch(setVersion(Game.version));
        dispatch(setMenu({ menuState: MenuOptions.NEW_GAME, display: false }));
        Action.head = null;
        Game.Action = null;
        Game.rollback = 0;
        Character.initCharacters();
        dispatch(resetIndex());
        dispatch({ type: "GAME_OBJECT_CLEAR" });
        funcs.start();

    };
    const onContinue = () => {
        dispatch(setMenu({ menuState: MenuOptions.CONTINUE, display: false }));
    };
    const onLoad = () => {
        dispatch(setMenu({ menuState: MenuOptions.LOAD, display: true }));
    };
    const onSave = () => {
        dispatch(setMenu({ menuState: MenuOptions.SAVE, display: true }));
    };
    const onSettings = () => {
        dispatch(setMenu({ menuState: MenuOptions.SETTINGS, display: true }));

    };
    const onCredit = () => {
        dispatch(setMenu({ menuState: MenuOptions.CREDIT, display: true }));

    };
    const onScenes = () => {
        dispatch(setMenu({ menuState: MenuOptions.SCENES, display: true }));

    };
    const onChangeMenu = (menuState: MenuOptions, display: boolean) => {
        dispatch(setMenu({ menuState, display }));

    };
    const _onPatreonPressed = () => {
        onPatreonPressed();
    };
    const _onSteamPressed = () => {
        onSteamPressed();
    };
    const _onDiscordPressed = () => {
        onDiscordPressed();


    };

    const onExit = () => {
        onExitGame();

    };
    const doAnimate = () => {
        Animated.timing(opacity.current, {
            toValue: 1,
            duration: isMobile() ? 0 : 1000,
            useNativeDriver: true
        }).start(({ finished }) => {
        });
    };
    const onHeaderClicked = () => {
        if (menuSlice.menuState === MenuOptions.SAVE || menuSlice.menuState === MenuOptions.LOAD) {
            return;
        }
        setPageJumpModal(true);
    };
    const onHeaderSubmit = (page: string | boolean) => {
        setPageJumpModal(false);
        if (!page || typeof page === "boolean") { return; }
        dispatch(setSettings({ page: Number(page) }));
    };

    const onMenuClick = (item: MenuOptions) => {
        switch (item) {
            case MenuOptions.NEW_GAME:
                onNewGame();
                break;
            case MenuOptions.CONTINUE:
                onChangeMenu(MenuOptions.CONTINUE, false);
                break;
            case MenuOptions.EXIT:
                onExit();
                break;
            default:
                onChangeMenu(item, true);
                break;
        }
    };

    const onPress = () => {
        // captureScreen({
        //     format: "jpg",
        //     quality: 0.8
        // }).then(
        //     uri => console.log("Image saved to", uri),
        //     error => console.error("Oops, snapshot failed", error)
        // );
    };

    return (
        <>

            <Animated.View style={[styles.container, { opacity: opacity.current }]}>
                <View style={{
                    opacity: Game.isReplayRunning ? 1 : 0, zIndex: Game.isReplayRunning ? 10 : -10,
                    width: "100%", height: "100%", justifyContent: "center", alignItems: "center", backgroundColor: "black", display: "flex", flexDirection: "row"
                }}>
                    <TouchableOpacity onPress={() => {
                        store.dispatch(setMenu({ display: false }));
                    }}>
                        <Text style={{
                            color: "white",
                            margin: 20,
                            fontSize,
                            borderWidth: 1,
                            borderColor: "white",
                            borderRadius: 10,
                            textAlign: "center",
                            paddingHorizontal: 20,
                            paddingVertical: 10,
                            backgroundColor: "#3a86ff"
                        }}>Continue</Text>

                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => {
                        endReplayFunc();
                    }}>
                        <Text style={{
                            color: "white",
                            margin: 20,
                            fontSize,
                            borderWidth: 1,
                            borderColor: "white",
                            borderRadius: 10,
                            textAlign: "center",
                            paddingHorizontal: 20,
                            paddingVertical: 10,
                            backgroundColor: "#ff6b81"
                        }}>End Replay</Text>

                    </TouchableOpacity>
                </View>
                <>
                    <WaitForLoadImage style={styles.menuImage} resizeMode={"cover"} source={background as any}></WaitForLoadImage>
                    <View style={styles.menuImage} >
                        <View style={styles.leftSide}>
                            {/* {height > 300 ? <View style={styles.header}><Text style={styles.headerText}>{menuItem}</Text></View> : <></>} */}
                            <View style={styles.sideBar}>
                                <SideBar onclick={(item) => onMenuClick(item)} ></SideBar>
                            </View>
                        </View>
                        <View style={styles.rightSide}>
                            {menuSlice.menuState !== MenuOptions.INIT ?
                                <View style={styles.header}>
                                    {(menuSlice.menuState === MenuOptions.SAVE || menuSlice.menuState === MenuOptions.LOAD) && pageJumpModal ? <PromptQuestionModal showCancel={true} defaultValue={menuSlice.settings.page?.toString()} placeHolder={"Jump to page"} onSubmit={(input) => onHeaderSubmit(input)}></PromptQuestionModal> : <></>}

                                    <Text onPress={() => onHeaderClicked()} style={styles.headerText}>{((menuSlice.menuState === MenuOptions.LOAD || menuSlice.menuState === MenuOptions.SAVE) ? `${menuSlice.menuState} - Page ${menuSlice.settings.page}` : `${menuSlice.menuState}`)}
                                    </Text>
                                    {(menuSlice.menuState === MenuOptions.LOAD || menuSlice.menuState === MenuOptions.SAVE) && !isMobile() ? <TPicker onValueChanged={onValueChanged}></TPicker> : <></>}

                                </View>
                                : <></>}

                            {menuSlice.menuState === MenuOptions.SAVE || menuSlice.menuState === MenuOptions.LOAD ? <SaveLoadScreen files={saves} setFiles={setSaves}></SaveLoadScreen> : <></>}
                            {/* {menuSlice.menuState === MenuOptions.LOAD ? <SaveLoadScreen></SaveLoadScreen> : <></>} */}
                            {isMobile() ? <></> : <>
                                {(menuSlice.menuState === MenuOptions.SCENES || menuSlice.menuState === MenuOptions.GALLERY) || (menuSlice.display === true && showGallery) ?
                                    <View style={{ position: "absolute", width: "100%", height: "83%", marginTop: "12%", zIndex: -1 }}>
                                        {menuSlice.menuState === MenuOptions.GALLERY ? <View style={{ display: menuSlice.menuState === MenuOptions.GALLERY ? "flex" : "none", position: "absolute", width: "100%", height: "100%", zIndex: menuSlice.menuState === MenuOptions.GALLERY ? 2 : -1, opacity: menuSlice.menuState === MenuOptions.GALLERY ? 1 : 0 }}>
                                            <Gallery></Gallery>

                                        </View> : <></>}
                                        <View style={{ display: menuSlice.menuState === MenuOptions.SCENES ? "flex" : "none", position: "absolute", width: "100%", height: "100%", zIndex: menuSlice.menuState === MenuOptions.SCENES ? 2 : -1, opacity: menuSlice.menuState === MenuOptions.SCENES ? 1 : 0 }}>
                                            <Achievements></Achievements>
                                        </View>
                                    </View>
                                    :
                                    <></>}
                            </>}
                            {menuSlice.menuState === MenuOptions.CREDIT ? <Credit></Credit> : <></>}
                            {/* {menuSlice.menuState === MenuOptions.SCENES ? <Achievements></Achievements> : <></>} */}
                            {/* {menuSlice.menuState === MenuOptions.GALLERY ? <Gallery></Gallery> : <></>} */}
                            {menuSlice.menuState === MenuOptions.SETTINGS ? <Settings></Settings> : <></>}
                        </View>
                    </View>
                    <View style={styles.upperButtonsRight}>
                        {/* <TouchableOpacity onPress={() => _onSteamPressed()}>
                            <Image style={styles.patreonLink} source={steamImage}></Image>
                        </TouchableOpacity> */}
                        <TouchableOpacity onPress={() => _onPatreonPressed()}>
                            <Image style={styles.patreonLink} source={patreonImage}></Image>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => _onDiscordPressed()}>
                            <Image style={[styles.patreonLink]} source={discordImage}></Image>
                        </TouchableOpacity>
                    </View>
                    <View style={styles.upperButtonsLeft}>

                        <TouchableOpacity onPress={() => _onSteamPressed()}>
                            <View style={{ display: "flex", flexDirection: "row" }}>
                                <Image style={styles.patreonLink} source={steamImage}></Image>
                                <Text style={{ alignSelf: "center", color: "white", fontSize: useFontSize(2) }}>
                                    <Text style={{}}>WISHLIST{"\n"} NOW</Text>
                                </Text>
                            </View>
                        </TouchableOpacity>


                    </View>
                    <View style={styles.upperButtonsRight}>
                        <Text style={{ bottom: 0, color: "white", position: "absolute" }}>{Game.version}</Text>
                    </View>
                    {/* <View style={styles.wishlistContainer}>
                        <TouchableOpacity onPress={() => _onDiscordPressed()}>
                            <Image style={[styles.wishlistImage]} source={wishlistImage}></Image>
                        </TouchableOpacity>
                    </View> */}
                    <View style={{
                        flex: 1,
                        width: "100%",
                        alignItems: "center",
                        flexDirection: "row",
                        left: "10%",
                        alignSelf: "center",
                        justifyContent: "center",
                        alignContent: "center"
                    }}>

                        <Text selectable={false} style={{
                            fontFamily: "serif",
                            fontWeight: "bold",
                            textShadowColor: 'rgba(0, 0, 0, 0.5)',
                            textShadowRadius: 1,
                            textShadowOffset: { width: 1, height: 1 },
                            textAlign: "center",
                            color: "white",
                            display: "flex",
                            flexDirection: "column",
                            fontSize: useFontSize(4)
                        }}>

                            {/* <Text style={{ alignSelf: "center" }}>
                                <Text style={{}}>Wishlist Long Story Short on Steam!</Text>
                                {"\n"}{"\n"}{"\n"}
                            </Text> */}
                        </Text>
                    </View>
                </>

            </Animated.View>
        </>
    );
};